import { Component, h, Prop, State } from '@stencil/core';
import { i18nConfig, presetAttributes } from '../../../../../interfaces';

/**
 * This component is needed to prevent re-rendering of
 * main component with currentTime changes.
 */
@Component({
  tag: 'zeudy-email-overlay',
  styleUrl: 'zeudy-email-overlay.css',
  shadow: false,
})
export class zeudyEmailOverlay {
  @Prop() player: any;
  @Prop() direction?: 'rtl';
  @Prop() preset: presetAttributes;
  @Prop() videoId: number;
  @Prop() i18n: i18nConfig;
  @Prop() provider: string;

  @State() currentTime: number;
  @State() duration: number;
  @State() ended: boolean;

  componentWillLoad() {
    if (!this.player) return;
    this.player.on('ended', () => this.setEnded());
    this.player.on('timeupdate', e => this.setCurrentTime(e));
  }

  setEnded() {
    this.ended = true;
  }

  setCurrentTime(e) {
    this.currentTime = e?.detail?.plyr.currentTime;
    this.duration = e?.detail?.plyr.duration;
  }

  /**
   * Remove listeners if destroyed
   */
  disconnectedCallback() {
    if (!this.player) return;
    this.player.off('ended', this.setEnded);
    this.player.off('timeupdate', this.setCurrentTime);
  }

  /**
   * Maybe render
   * @returns JSX
   */
  render() {
    return (
      <zeudy-email-overlay-controller
        ended={this.ended}
        currentTime={this.currentTime}
        videoId={this.videoId}
        duration={this.duration}
        direction={this.direction}
        presetId={this.preset?.id}
        emailCollection={this.preset?.email_collection}
        i18n={this.i18n}
        provider={this.provider}
      ></zeudy-email-overlay-controller>
    );
  }
}
